import { IconCheckCircle } from "../icon/variants/IconCheckCircle.js";
import { Flex } from "../mantine-passthroughs/index.js";
import { Subtitle2 } from "../typography/Subtitle2.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/progress-bar/MinMaxLabels.tsx
const MinMaxLabels = ({ min, value, max, maxFormatter, minFormatter, showComplete }) => {
	return /* @__PURE__ */ jsxs(Flex, {
		justify: "space-between",
		children: [/* @__PURE__ */ jsx(Label, {
			limit: min,
			value,
			formatter: minFormatter
		}, "min-label"), /* @__PURE__ */ jsx(Label, {
			limit: max,
			value,
			formatter: maxFormatter,
			Icon: value >= max && showComplete ? /* @__PURE__ */ jsx(IconCheckCircle, { color: "success" }) : void 0
		}, "max-label")]
	});
};
const Label = ({ value, limit, formatter, Icon }) => {
	if (Icon) return Icon;
	const formatted = formatter?.(limit, value) ?? limit;
	return typeof formatted === "number" ? /* @__PURE__ */ jsx(Subtitle2, { children: formatted }) : formatted;
};

//#endregion
export { MinMaxLabels };